import React from "react";
import nextId from "react-id-generator";
import { Images } from "../../Assets/0a-exporter";
import CommonFooter from "../LandingPage/CommonFooter/CommonFooter";
import LandingHeader from "../LandingPage/LandingHeader/LandingHeader";
import "./about-page.style.scss";
export default function AboutPage() {
  return (
    <div className="about-page-main">
      <LandingHeader opaque="opaque" />
      <div className="apm-header">
        <img src={Images.dotsGrayBottomLeft} />
        <img src={Images.dotsGrayTopRight} />
        <h4>Our Organization</h4>
        <p>
          AcadsHR, working round the clock 24/7, now caters to candidates and
          institutions across different time zones.
        </p>
      </div>
      <div className="apm-comment">
        <div className="apm-comment-left">
          <h4>Vision and Mission</h4>
          <img src={Images.blueComments} />
          <p>
            Our solution offers candidates with a quick search and apply for
            suitable jobs. We do not charge any placement fee from the
            candidates. We ensure data protection, which is utmost important for
            any individual. For the Institutions, we help them with job posts
            and find the right talent through a SmartMatch solution.
          </p>
          <p>
            AcadsHR is an HR Consulting company for Educational Institutions. We
            started in Bengaluru, India in 2017 and subsequently extended to Abu
            Dhabi, UAE in 2019.
          </p>
        </div>
        <div className="apm-comment-right">
          <img src={Images.employees} />
        </div>
      </div>
      <div className="apm-team">
        <div className="apm-team-header">
          <h4>Meet our team</h4>
          <p>
            We’re lead by a team who constantly questions, tinkers, and
            challenges to unlock great creativity around every turn
          </p>
        </div>
        <div className="apm-team-body">
          {peoples.map((obj) => (
            <div key={obj.keyId} className="people-card-wrapper">
              <div className="people-card">
                <figure>
                  <img src={Images.human} />
                </figure>
                <figcaption>
                  <h5>{obj.name}</h5>
                  <p>{obj.post}</p>
                </figcaption>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div
        style={{ backgroundImage: `url(${Images.meeting})` }}
        className="apm-states"
      >
        <div className="apm-s-overlay">
          <h5>People choose us because we serve the best for everyone</h5>
          <div className="aps-s-wrapper">
            <div>
              <h2>3L+</h2>
              <p>Candidate Database</p>
            </div>

            <div>
              <h2>1K+</h2>
              <p>Jobs Posted</p>
            </div>
            <div>
              <h2>300+</h2>
              <p>Clients</p>
            </div>
          </div>
        </div>
      </div>
      <div className="aps-benefits">
        <div className="apps-benefits-header">
          <h4>Benefits of working with us</h4>
          <p>
            AcadsHR, working round the clock 24/7, now caters to candidates and
            institutions across different time zones.
          </p>
        </div>
        <div className="apps-benefits-body">
          {benefits.map((obj) => (
            <div className="benefit-card">
              <div className="benefit-card-left">
                <img src={obj.icon} />
              </div>
              <div className="benefit-card-right">
                <h6>{obj.title}</h6>
                <p>{obj.info}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <CommonFooter />
    </div>
  );
}
const peoples = [
  { keyId: nextId(), name: "TT Jagannathan", post: "Chairman, Division" },
  { keyId: nextId(), name: "TT Jagannathan", post: "Chairman, Division" },
  { keyId: nextId(), name: "TT Jagannathan", post: "Chairman, Division" },
  { keyId: nextId(), name: "TT Jagannathan", post: "Chairman, Division" },
  { keyId: nextId(), name: "TT Jagannathan", post: "Chairman, Division" },
  { keyId: nextId(), name: "TT Jagannathan", post: "Chairman, Division" },
  { keyId: nextId(), name: "TT Jagannathan", post: "Chairman, Division" },
  { keyId: nextId(), name: "TT Jagannathan", post: "Chairman, Division" },
  { keyId: nextId(), name: "TT Jagannathan", post: "Chairman, Division" },
  { keyId: nextId(), name: "TT Jagannathan", post: "Chairman, Division" },
  { keyId: nextId(), name: "TT Jagannathan", post: "Chairman, Division" },
];
const benefits = [
  {
    keyId: nextId(),
    title: "Industry Knowledge",
    info: "Industry experienced professionals backed by thought leaders in education industry",
    icon: Images.bcOne,
  },
  {
    keyId: nextId(),
    title: "Customized Solution",
    info: "Our service is tailored to your school's HR needs with high quality advice.",
    icon: Images.bcTwo,
  },
  {
    keyId: nextId(),
    title: "Industry Proven Solution",
    info: "We draw from our rich hands-on experience in this domain to design viable and result-oriented solutions.",
    icon: Images.bcThree,
  },
  {
    keyId: nextId(),
    title: "End to End Service",
    info: "End to End cost effective HR services at one place, They helped me to get an opportunity during this tough time",
    icon: Images.bcFour,
  },
  {
    keyId: nextId(),
    title: "Time for Quality Education",
    info: "We take care all HR needs so that you could spend time on quality education",
    icon: Images.bcFive,
  },
  {
    keyId: nextId(),
    title: "Teacher 360",
    info: "A Developmental Program designed to Evaluate and Enrich Teacher Competencies.",
    icon: Images.bcSix,
  },
];
